import {Component, OnInit} from '@angular/core';
import {UserService,ScrollService} from '../../../api/';
import {User} from '../../../../models';
import {Router} from '@angular/router';
import {MdDialog, MdDialogRef} from '@angular/material';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
    selector: 'app-billing',
    templateUrl: './billing.component.html',
    styleUrls: ['./billing.component.css']
})
export class BillingComponent implements OnInit {
    public model: User;
    public countries: Array<any> = new Array<any>();
    public usStates: Array<any> = new Array<any>();
    public usCities: Array<any> = new Array<any>();
    public canadaCities: Array<any> = new Array<any>();
    public canadaProvinces: Array<any> = new Array<any>();
    private errorArray = [];
    public cntry: any;
    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline1: boolean = navigator.onLine;

    constructor(private scrollService:ScrollService,private userService: UserService, private router: Router, public dialog: MdDialog) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});

        this.model = new User();

    }

    getUserProfileData(cntry?) {
        if(this.onlineOffline1){
        this.userService.getUserProfileData().subscribe((res) => {
            console.log(res.profile);
            this.model.fullname = res.profile.firstname + " " + res.profile.lastname;
            this.model.firstname = res.profile.firstname;
            this.model.lastname = res.profile.lastname;
            this.model.address1 = res.profile.address1;
            this.model.town_city = res.profile.town_city;
            this.model.state_region = res.profile.state_region;
            this.model.postalcode = res.profile.postalcode;
            // to check if other steps are already filled
            const status = localStorage.getItem('status');
            if(status > res.profile.status) {
                this.model.status = status;
            } else {
                this.model.status = res.profile.status;
            }
            localStorage.setItem('status', this.model.status);
            if (res.profile.country) {
                this.model.country = res.profile.country;
            } else {
                this.model.country = cntry;
            }
        }, (err) => {
        });
        }
    }

    submitBilling() {
        this.blockUI.start('Loading, please wait...');
        this.model.fullname = this.model.firstname + " " + this.model.lastname;
        if(this.onlineOffline1){
        this.userService.saveBilling(this.model).subscribe((res) => {
            this.router.navigate(['/payment-info'], {queryParams: {check: true}});
        }, (err) => {
            this.handleErrors(err);
        });
        }
        this.blockUI.stop(); // Stop blocking

    }

    ngOnInit() {
        if(this.onlineOffline1){
        this.userService.getCountries().subscribe((res) => {
            this.countries = res;
            for (var i = 0; i < this.countries.length; i++) {
                if (this.countries[i].name == "United States") {
                    this.cntry = this.countries[i].code;
                }
            }
            this.getUserProfileData(this.cntry);

        });
        this.userService.getStates().subscribe((res) => {
            this.usStates = res;
        });

        this.userService.getProvinces().subscribe((res) => {
            this.canadaProvinces = res;
        });
        this.userService.getCities().subscribe((res) => {
            this.usCities = res;
        });
        this.userService.getCanadaCities().subscribe((res) => {
            this.canadaCities = res;
        });
        }
        this.scrollService.enableScrollIfDisabled();
        this.blockUI.stop(); // Stop blocking
    }

    stateInput(value) {
        if (value == "US") {

            document.getElementById("inputState").style.display = "none";
            document.getElementById("dropdownProvince").style.display = "none";
            document.getElementById("dropdownState").style.display = "block";
        } else if (value == "CA") {

            document.getElementById("inputState").style.display = "none";
            document.getElementById("dropdownProvince").style.display = "block";
            document.getElementById("dropdownState").style.display = "none";
        } else {

            document.getElementById("dropdownProvince").style.display = "none";
            document.getElementById("dropdownState").style.display = "none";
            document.getElementById("inputState").style.display = "block";
        }
    }

    stateInput2(value) {
        if (this.model.country == "US") {
            for (var i = 0; i < this.usCities.length; i++) {
                if (value == this.usCities[i].zip_code) {
                    this.model.town_city = this.usCities[i].city;
                    this.model.state_region = this.usCities[i].state;
                    return;
                }
            }
        }
        if (this.model.country == "CA") {
            for (var i = 0; i < this.canadaCities.length; i++) {
                if (value == this.canadaCities[i].PostalCode) {
                    this.model.town_city = this.canadaCities[i].PlaceName;
                    this.model.state_region = this.canadaCities[i].Province;
                    return;
                }
            }
        }
    }

    onChange(newValue) {

        if (newValue == "US") {

            document.getElementById("inputState").style.display = "none";
            document.getElementById("dropdownProvince").style.display = "none";
            document.getElementById("dropdownState").style.display = "block";
        } else if (newValue == "CA") {

            document.getElementById("inputState").style.display = "none";
            document.getElementById("dropdownProvince").style.display = "block";
            document.getElementById("dropdownState").style.display = "none";
        } else {

            document.getElementById("dropdownProvince").style.display = "none";
            document.getElementById("dropdownState").style.display = "none";
            document.getElementById("inputState").style.display = "block";
        }
    }

    onChange1(newValue) {

        if (this.model.country == "US") {
            for (var i = 0; i < this.usCities.length; i++) {
                if (newValue == this.usCities[i].zip_code) {
                    this.model.town_city = this.usCities[i].city;
                    this.model.state_region = this.usCities[i].state;
                    return;
                }
            }
        }
        if (this.model.country == "CA") {
            for (var i = 0; i < this.canadaCities.length; i++) {
                if (newValue == this.canadaCities[i].PostalCode) {
                    this.model.town_city = this.canadaCities[i].PlaceName;
                    this.model.state_region = this.canadaCities[i].Province;
                    return;
                }
            }
        }
    }

    handleErrors(err: any) {
        this.errorArray = [];
        let validationErrors = JSON.parse(err._body);
        if (err._body) {
            for (let index = 0; index < validationErrors.length; index++) {
                this.errorArray[validationErrors[index].field] = validationErrors[index].message;
            }
        }
    }

}

@Component({
    selector: 'payment-pending-dialog',
    template: `
        <md-toolbar color="primary">
            <span> Billing Information needed. </span>
            <span class="demo-fill-remaining"></span>
            <span>
                <a>
                    <md-icon svgIcon="ic_close_24px.svg" (click)="dialogRef.close()"
                             mdTooltip="{{ 'CLOSE' | tooltip }} " mdTooltipPosition="above"> </md-icon>
                </a>
            </span>
        </md-toolbar>
        <div class='modal-content'>
            <div fxLayout="row" fxLayout.gt-md="row">
                <br>
                It seems that your payment method is not setup yet. Please provice information for your payment
                <br><br>
            </div>
            <div fxLayout="row">
                <button md-raised-button (click)="dialogRef.close()" color="primary">Skip</button>
                <button md-raised-button (click)="goToPayments()" color="primary">Go To Payments</button>
            </div>
        </div>
    `
})
export class PaymentPendingComponent {
    constructor(public dialogRef: MdDialogRef<any>, private router: Router) {
    }

    goToPayments() {
        this.dialogRef.close(false);
        this.router.navigate(['payment-info']);
    }
}



// WEBPACK FOOTER //
// ./src/app/user/signup/billing/billing.component.ts